const en = {
  common: {
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    confirm: "Confirm",
    back: "Back",
    search: "Search",
    all: "All",
    yes: "Yes",
    no: "No",
    done: "Done",
    error: "Error",
    success: "Success",
    retry: "Retry",
    copy: "Copy",
    copied: "Copied",
    viewAll: "View all",
    noData: "No data",
    unknownError: "An unknown error occurred",
    required: "This field is required",
    optional: "Optional",
    amount: "Amount",
    price: "Price",
    quantity: "Quantity",
    status: "Status",
    date: "Date",
    actions: "Actions",
    today: "Today",
    last7days: "Last 7 days",
    last30days: "Last 30 days",
    noResults: "No results",
    available: "Available",
    codes: "Codes",
    count: "Quantity",
    total: "Total",
    unavailable: "Unavailable",
    options: "Options",
    view: "View",
    delete: "Delete",
    copyNumber: "Copy number",
    copyCode: "Copy code",
    cardNotFound: "Card not found",
    discount: "Discount {{discount}}%",
    shippedFast: "Shipped fast via player ID",
    unknown: "Unknown",
  },
  nav: {
    brandSub: "Digital cards platform",
    menu: "Menu",
    services: "Services",
    home: "Home",
    wallet: "Wallet",
    orders: "Orders",
    deposit: "Add Balance",
    balance: "Balance",
    virtualNumbers: "Virtual Numbers",
    agents: "Agents",
    support: "Support",
    notifications: "Notifications",
    favorite: "Favorites",
    profile: "My Profile",
    logout: "Logout",
  },
  header: {
    menu: "Menu",
    notifications: "Notifications",
    darkMode: "Dark mode",
    lightMode: "Light mode",
    language: "Language",
    changeLanguage: "Change language",
  },
  auth: {
    brandTagline: "The leading digital cards platform in the region",
    brandDesc: "Buy, send and receive your cards and bundles instantly, securely and fast.",
    feature1: "Instant & secure delivery",
    feature2: "Full account protection",
    feature3: "Best prices daily",
    loginTitle: "Sign In",
    loginSub: "Enter your credentials to access your dashboard.",
    email: "Email",
    emailPlaceholder: "name@tstore.com",
    password: "Password",
    passwordPlaceholder: "••••••••",
    showPassword: "Show password",
    rememberMe: "Remember me",
    forgotPassword: "Forgot password?",
    login: "Login",
    or: "or",
    google: "Google",
    facebook: "Facebook",
    noAccount: "Don't have an account?",
    createAccount: "Create one now",
    loginError: "Incorrect email or password",
    registerTitle: "Create Account",
    registerSub: "Complete your details to create a new account.",
    firstName: "First name",
    lastName: "Last name",
    registerSubGate: "Enter your details to start using the platform.",
    registerDone: "Registration request received (demo).",
    pwHint: "Use at least 8 characters with a symbol and a number.",
    terms: "I agree to the Terms of Service and Privacy Policy.",
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    orRegisterWith: "or sign up with",
    joinTagline: "Join the leading digital cards platform in the region",
    joinDesc: "Create your account in seconds and get your cards and bundles instantly, securely and fast.",
    name: "Name",
    confirmPassword: "Confirm password",
    register: "Register",
    haveAccount: "Already have an account?",
    loginInstead: "Sign in",
    registerSuccess: "Account created successfully",
    passwordMismatch: "Passwords do not match",
    registerMissing: "Please fill in your name, email and password.",
    registerPassMismatch: "Passwords do not match.",
    registerFailed: "Could not create the account. Please try again.",
  },
  home: {
    crumbHome: "Home",
    crumbOverview: "Overview",
    welcome: "Hello {{name}} 👋",
    welcomeDesc: "Here is a summary of your account and today's latest available cards.",
    history: "Transaction history",
    charge: "Top up balance",
    news: "News",
    currentBalance: "Current balance",
    featured: "Featured cards & bundles",
    availableCards: "Available cards",
    categories: "Categories",
    chooseCategory: "Browse categories",
    allCategories: "All",
    noCardsInCategory: "No cards in this category",
    allCards: "All cards",
    latestOrders: "Latest orders",
    fullHistory: "Full history",
    orderId: "Order ID",
    product: "Product",
    orderDate: "Date",
    orderStatus: "Status",
    noOrders: "No orders yet",
    stat: "Statistic",
    statusCompleted: "Completed",
    statusCancelled: "Cancelled",
    statusPending: "In progress",
  },
  wallet: {
    title: "Wallet",
    balance: "Wallet balance",
    balanceIn: "Incoming",
    balanceOut: "Outgoing",
    pending: "Pending",
    deposit: "Deposit",
    withdraw: "Withdraw",
    history: "Transaction history",
    noHistory: "No transactions yet",
    reason: "Reason",
    transactionDate: "Transaction date",
    transactionType: "Transaction type",
    desc: "Details of your balance and financial movements.",
    pendingApproval: "Pending approval",
    txnId: "Transaction #",
    operation: "Operation",
    // ===== Balance movement log (clear table) =====
    type: "Type",
    reference: "Reference",
    details: "Details",
    amountEffect: "Balance effect",
    balanceAfter: "Balance after",
    refOrder: "Order #{{id}}",
    refDeposit: "Deposit #{{id}}",
    refNone: "-",
    opDepositAccepted: "Deposit accepted",
    opDepositOther: "Deposit",
    opPurchase: "Card purchase",
    opRefund: "Amount refunded",
    opAdminAdd: "Admin credit",
    opAdminRemove: "Admin debit",
    opOther: "Balance movement",
    descDepositAccepted: "Your balance was credited from an accepted deposit",
    descPurchase: "Card purchase amount deducted",
    descRefund: "Refund for a cancelled or rejected order",
    descAdminAdd: "Manual credit by admin",
    descAdminRemove: "Debit by admin",
    descGenericAdd: "Credit to balance",
    descGenericRemove: "Debit from balance",
    // ===== Complete client ledger (deposits & orders in every state) =====
    opDepositPending: "Deposit under review",
    opDepositRejected: "Deposit rejected",
    opOrderPending: "Order in progress",
    opOrderRejected: "Order rejected",
    opOrderCompleted: "Order completed",
    descDepositPending: "Your deposit request is awaiting admin approval",
    descDepositRejected: "Your deposit request was rejected, no balance was added",
    descOrderPending: "Your order is being processed",
    descOrderRejected: "Your order was rejected, the amount was refunded to your balance",
    descOrderCompleted: "Your order was completed successfully",
    statusPendingReview: "Under review",
    statusRejected: "Rejected",
    statusAccepted: "Accepted",
    noEffect: "No balance change",
  },
  deposit: {
    title: "Add Balance",
    methods: "Deposit methods",
    chooseMethod: "Choose a deposit method",
    amount: "Amount",
    enterAmount: "Enter amount",
    fee: "Fee",
    total: "Total",
    instructions: "Payment instructions",
    confirmDeposit: "Confirm deposit",
    depositSuccess: "Deposit request sent",
    walletAddress: "Wallet address",
    qrCode: "QR code",
    crypto: "Crypto",
    desc: "Choose the top-up method that suits you.",
    methodsAvailable: "Available top-up methods",
    paymentMethod: "Payment method",
    completeTransferDesc: "Complete the transfer details then confirm the payment.",
    infoTitle: "Deposit information",
    fillTitle: "Details required from you",
    noInfo: "No additional deposit information for this method.",
    commission: "Commission",
    emailLabel: "Email",
    orEmail: "or email",
    recipientName: "Recipient name",
    phone: "Phone",
    city: "City",
    scanBarcode: "Scan the barcode to transfer:",
    scanQr: "Scan the wallet QR to transfer:",
    senderName: "Sender name",
    amountWithFee: "Amount including transfer fees",
    amountHint: "Enter the amount you want credited to your balance (the amount we actually receive after the transfer company deducts its fee). Example: if you pay 1005 to the company and we receive 1000, enter 1000. Currency conversion to USD is done by the admin on review.",
    amountHintCrypto: "Enter the amount you want to top up **in USD** — this is what gets credited to your balance. Example: to top up 100 USD with BTC, enter 100 (not the BTC value). It will be converted to BTC (or the coin you pick) automatically via NowPayments; the USD amount is what is credited.",
    amountHintCryptoNote: "Note: do NOT enter the crypto value (e.g. 0.0015 BTC) — enter the USD amount only. The provider calculates the equivalent automatically.",
    transferOffice: "Transfer office",
    cryptoCurrency: "Crypto currency",
    noticeOrTransferNumber: "Notice or transfer number",
    note: "Note",
    notePlaceholder: "Anything",
    confirmPayment: "Confirm payment",
    cryptoInvoiceFailed: "Could not create the provider payment invoice. Please try again or contact support.",
    amountRequired: "Please enter a valid amount greater than zero.",
    receiptRequired: "Please attach the required receipt:",
    fieldRequired: "Please fill the required field:",
    submitFailed: "Could not submit the deposit request. Please try again.",
    done: "Deposit request submitted successfully.",
    pendingExists: "You already have a deposit under review. Please wait for it to be processed before sending a new request.",
    turnstileFailed: "Security verification failed. Please try again.",
    uploadPdfHint: "Upload the receipt file (PDF or image)",
    uploadImageHint: "Upload an image",
  },
  orders: {
    title: "Orders",
    all: "All",
    completed: "Completed",
    cancelled: "Cancelled",
    pending: "In progress",
    delivered: "Delivered",
    inProgress: "In progress",
    noOrders: "No orders",
    searchPlaceholder: "Search by order ID or product",
    orderDetails: "Order details",
    productName: "Product name",
    quantity: "Quantity",
    totalPrice: "Total price",
    orderDate: "Order date",
    status: "Status",
    code: "Code",
    note: "Note",
    activation: "Activation details",
    card: "Card",
    desc: "Track all your orders and wallet.",
    allOrders: "All orders",
    incomplete: "Incomplete",
    filterPlaceholder: "Search card, player ID or order number without #",
  },
  viewOrder: {
    orderId: "Order #{{id}}",
    desc: "Your order details and code if available.",
    created: "Created at",
    executed: "Executed at",
    info: "Order info",
    playerId: "Player ID",
    item: "Item",
    checkStatus: "Check order status",
    cancel: "Cancel order",
  },
  profile: {
    title: "My Profile",
    name: "Name",
    email: "Email",
    phone: "Phone number",
    address: "Address",
    telegram: "Telegram ID",
    avatar: "Avatar",
    updateProfile: "Update profile",
    changePassword: "Change password",
    oldPassword: "Current password",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    profileUpdated: "Profile updated successfully",
    passwordChanged: "Password changed",
    desc: "Manage your account info and password",
    changePhoto: "Change photo",
    updateMyInfo: "Update my personal info",
    fullName: "Full name",
    changeCurrentPassword: "Change current password",
    passwordHint: "Please enter your current password first, then the new password",
    currentPw: "Current password",
    newPw: "New password",
    newPwPlaceholder: "Enter new password",
    confirmPwPlaceholder: "Confirm your new password",
    passwordChangedSuccess: "Password changed successfully",
  },
  tickets: {
    title: "Support",
    newTicket: "New ticket",
    ticketTitle: "Ticket title",
    priority: "Priority",
    low: "Low",
    medium: "Medium",
    high: "High",
    message: "Message",
    send: "Send",
    myTickets: "Support tickets",
    noTickets: "No tickets",
    open: "Open",
    closed: "Closed",
    reply: "Reply",
    replyPlaceholder: "Type your reply here...",
    sendReply: "Send reply",
    desc: "Track your support tickets or open a new one",
    openNew: "Open new ticket",
    subject: "Subject",
    ticket: "Ticket",
    ticketId: "Ticket ID",
    you: "You",
    support: "Support",
    writeComment: "Write your comment here",
    commentPlaceholder: "Here....",
    sendComment: "Send comment",
  },
  notifications: {
    title: "Notifications",
    noNotifications: "No notifications",
    markAllRead: "Mark all as read",
    desc: "Follow the latest alerts and messages",
  },
  favorite: {
    title: "Favorites",
    empty: "No favorite items",
    remove: "Remove from favorites",
    desc: "Your favorite cards and bundles",
    countRange: "Minimum is {{min}} and maximum is {{max}}",
    add: "Add to favorites",
    added: "Favorited",
  },
  search: {
    title: "Search",
    placeholder: "Search for a card or bundle...",
    desc: "Search for the available cards and bundles",
    noResults: "No results",
    results: "Search results",
    homePlaceholder: "Search for a card, bundle, or order...",
  },
  buy: {
    title: "Purchase",
    item: "Product",
    quantity: "Quantity",
    total: "Total",
    buy: "Buy",
    playerId: "Player ID",
    email: "Receiving email",
    confirm: "Confirm purchase",
    buySuccess: "Order created successfully",
    available: "Available",
    buyNow: "Buy now",
    desc: "Choose the right bundle and start buying",
    messageLabel: "Message:",
    codeLabel: "Code:",
    stateLabel: "State:",
    confirmPurchaseText: "Confirm your purchase",
    availableBalance: "Your available balance",
    playerIdPlaceholder: "Account ID",
    email: "Receiving email",
    emailPlaceholder: "Email the code/activation will be sent to",
    emailRequired: "Email is required to complete this order",
    playerIdRequired: "Player ID is required to complete this order",
    phone: "Phone number",
    phonePlaceholder: "Phone number required for activation",
    phoneRequired: "Phone number is required to complete this order",
    accountName: "Account name",
    accountNamePlaceholder: "Player account name",
    productDetails: "Product details",
    moreDetails: "Extended details",
    cardDetails: "Card details",
    minOrder: "Minimum order quantity is: {{min}}",
    maxOrder: "Maximum order quantity is: {{max}}",
    bundleUnavailable: "This bundle is currently unavailable",
    purchaseFailed: "Unable to complete the purchase. Please try again.",
  },
  orderResult: {
    titleSuccess: "Your order has been received",
    codeTitle: "Code delivered successfully",
    codeDesc: "Your order was executed and the code was drawn instantly. You can copy it below, and it was also sent to your email.",
    manualTitle: "Your order is recorded, pending activation",
    manualDesc: "Your order is a manual transfer; the support team will process and activate it. You will receive an email notification once activation is complete.",
    externalTitle: "Your order is being processed by the external provider",
    externalDesc: "Your order was sent to the external provider and is being processed. You will receive an email notification when execution completes and the code arrives.",
    insufficientTitle: "Insufficient balance",
    insufficientDesc: "You do not have enough balance to complete this purchase. Please top up your balance and try again.",
    sentToEmail: "The code was sent to your email: {{email}}",
    viewOrder: "Order details",
    backHome: "Back to home",
  },
  gateway: {
    title: "Payment Gateway",
    choose: "Choose a payment gateway",
    pay: "Pay now",
    processing: "Processing...",
    desc: "Complete your purchase through the gateway.",
    hint: "Choose the bundle and enter your email to complete.",
    buyNow: "Buy now",
    selectAndEmail: "Please select a card and enter your email",
  },
  virtualNumbers: {
    title: "Virtual Numbers",
    country: "Country",
    service: "Service",
    phone: "Phone number",
    price: "Price",
    status: "Status",
    getNumber: "Get number",
    myActivations: "My activations",
    noActivations: "No activations",
    code: "Code",
    sms: "Message",
    expires: "Expires in",
    activationTitle: "Virtual number activation",
    desc: "Get a temporary number to receive app activation codes via SMS",
    active: "active",
    heroTitle: "Virtual numbers to activate apps",
    heroDesc: "Choose the country and service and receive the activation code instantly — at the best prices.",
    searchPlaceholder: "Search for an app (WhatsApp, Google, TikTok...)",
    getNumberError: "Failed to get a number",
    noServices: "No matching services",
    viewPrices: "View prices",
    chooseCountry: "Choose a country to buy an activation number",
    noPrices: "No prices available for this service right now",
    buyNumber: "Buy number",
    recentActivations: "Recent activations",
    myActivationsDesc: "All your temporary numbers and their details",
    buyNewNumber: "Buy a new number",
    number: "Number",
    activationNotFoundTitle: "Activation not found",
    activationDetails: "Activation details",
    smsReceivedTitle: "SMS received",
    checkSms: "Check SMS",
    cancelNumber: "Cancel number",
    statusPendingSms: "Waiting for SMS",
    statusSmsReceived: "SMS received",
    statusCompleted: "Completed",
    statusCancelled: "Cancelled",
  },
  agent: {
    title: "Agents",
    comingSoon: "Coming soon",
    desc: "Agents dashboard and upcoming features",
    dashboard: "Agent Dashboard",
    comingSoonDesc: "Agent features coming soon",
    viewTickets: "View Tickets",
    backHome: "Back to Home",
  },
};

export default en;
